import { memo } from 'react'
import { Skeleton } from '../Skeleton'

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline' | 'ghost'
  isLoading?: boolean
  // Shows a pulsing placeholder in the button's shape while the form it acts on loads
  skeleton?: boolean
}

export const Button = memo(
  ({
    variant = 'primary',
    className,
    type = 'button',
    children,
    isLoading,
    disabled,
    skeleton,
    ...rest
  }: ButtonProps) => {
    if (skeleton) {
      return <Skeleton shape="button" />
    }
    const classes = ['btn', `btn--${variant}`, isLoading ? 'btn--loading' : '', className ?? '']
      .filter(Boolean)
      .join(' ')

    return (
      <button
        type={type}
        className={classes}
        disabled={disabled || isLoading}
        aria-busy={isLoading}
        {...rest}>
        {isLoading ? (
          <>
            <span className="btn__spinner" aria-hidden="true" />
            <span className="sr-only">Loading...</span>
          </>
        ) : (
          children
        )}
      </button>
    )
  },
)

Button.displayName = 'Button'
